/**
 * @name CommentLog
 * @description Bitácora de comentarios un backup
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

import { EmployeeDetail } from '@tycommon/components';
import { Typography, Flex } from '@tycommon/styles';

const CommentLog = ({ photo, name, date, comment, estatus }) => {

  const getActionLabel = (typeAction) => {
    switch (typeAction) {
      case 1: return i18n.t('BackupSettings.createdBackup');
      case 2: return i18n.t('BackupSettings.rejectedBackup');
      case 3: return i18n.t('BackupSettings.canceledBackup');
      case 4: return i18n.t('BackupSettings.madeBackup');
      default: break;
    }
  };

  return (
    <Flex.Col>
      <Flex.Row padding="8px" wrap>
        {/* Colaborador */}
        <EmployeeDetail
          avatar={photo ? photo : 'https://s3-us-west-1.amazonaws.com/ty-assets/icons/reconocimientos/aunporreconocer.png'}
          employeeName={name ? name : 'Talentry'}
          employeeDetail={getActionLabel(estatus)}

        />
        {/* Fecha */}
        <Styled.FlexDate>
          <Typography.Text>{moment(date).format(i18n.t('FormatDates.short'))}</Typography.Text>
          <Typography.Text color="greyDarkAlpha">{moment(date).format('hh:mm A')}</Typography.Text>
        </Styled.FlexDate>

      </Flex.Row>
      <Flex.Row padding="8px" alignItems="initial">
        <Styled.LineComment type={1} />
        <Flex.Col flex="1" margin="8px 0">
          {/* Comentario */}
          <Typography.Text style={{ whiteSpace: 'pre-line' }}>{comment}</Typography.Text>

        </Flex.Col>
      </Flex.Row>
    </Flex.Col>
  );
};

CommentLog.propTypes = {
  // URL de la foto del empleado del comentario.
  photo: PropTypes.string,
  // Nombre del empleado del comentario.
  name: PropTypes.string.isRequired,
  // Fecha del comentario.
  date: PropTypes.string.isRequired,
  // Comentario.
  comment: PropTypes.string.isRequired,
  // Comentario.
  estatus: PropTypes.number.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

Styled.FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
`;

Styled.FlexComment = styled.div`
  display: flex;
  padding: 0px 8px;
  margin-top: 8px;
`;

Styled.FlexDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-left: 16px;
  & > p { line-height: 1.3; }
`;


Styled.LineComment = styled.div`
  margin: 0 34px 0 18px;
  border: ${(props) => props.type === 1 && `2px solid ${props.theme.colors.blueDark}`};
  border-radius: 6px;
  background-color: ${(props) => props.type === 1 && props.theme.colors.blueDark};
`;

export default CommentLog;
